import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import BreadCrump from '../tools/breadcrump';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import ImageUploaders from '../tools/uploaderimages';
import { Button, Input, Placeholder, Tabs } from 'rsuite';
import { Select } from '@mui/material';
import QACreator from '../Qa/QaComponent';
import { url } from 'inspector';

import PriceEditor from './PriceEditor';
import HeaderOfPage from '../tools/headerOfPage';
import ColorManager from './ColorManager';

export default function EditProducts() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [list, setListArticle] = useState<any>(null);
    const [brands, setBrands] = useState<any[]>([]);
    const [pricellist, setPriceList] = useState<any[]>([]);
    const [data, setData] = useState<any>(null);
    const [feature, setFeature] = useState<any>([]);
    const [keyprice, setKeyprice] = useState<any>(1);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const save = async () => {
        try {
            setSaving(true);
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;
            // Ensure colors is always an array
            var x = {
                ...data,
                colors: Array.isArray(data.colors) ? data.colors : []
            };
            console.log('Saving product with colors:', x.colors);
            let res = await axios({
                method: 'put',
                data: x,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: 'موفق',
                text: 'اطلاعات با موفقیت بروزرسانی شد',
                confirmButtonText: 'باشه',
                timer: 2000
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'خطا',
                text: error.response?.data?.message || 'خطایی در بروزرسانی اطلاعات رخ داد',
                confirmButtonText: 'باشه'
            });
        } finally {
            setSaving(false);
        }
    }
    const load = async () => {
        try {
            setLoading(true);
            var path = `${config.url}/v1/dashboard/pproducts/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            // Ensure colors array exists
            const productData = {
                ...res.data.message,
                colors: Array.isArray(res.data.message.colors) ? res.data.message.colors : [],
                isExisting: res.data.message?.isExisting !== false,
                unlimitedStock: res.data.message?.unlimitedStock !== false,
                stockCount: res.data.message?.stockCount ?? 0,
            };
            console.log('Loaded product colors:', productData.colors);
            setData(productData);
            setFeature(res.data.feature);
            //  CreatePriceGroupFirst(res.data.message.id);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'خطا',
                text: 'خطایی در بارگذاری اطلاعات رخ داد',
                confirmButtonText: 'باشه'
            });
        } finally {
            setLoading(false);
        }
    }
    const getalldata = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/pgroup',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


            setListArticle(res.data.message);
        } catch (error) {


        }
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/productprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setPriceList(res.data.message);
        } catch (error) {
            // Error handling
        }
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/brands',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            // Handle different response formats
            const brandsData = res.data?.message || res.data || [];
            setBrands(Array.isArray(brandsData) ? brandsData : []);
        } catch (error) {
            setBrands([]); // Set empty array on error
        }
    }
    const inputstyle = "py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 disabled:opacity-50 disabled:pointer-events-none disabled:bg-gray-100";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'List Products',
            url: '/dashboard/Products/Products'
        },
        {
            name: 'Edit Product',
            url: null
        },
    ]
    const CreatePriceGroup = async () => {
        try {
            let res = await axios({
                method: 'post',
                data: {
                    name: data.id,
                    model: 'selfprice',
                    url: data.id
                },
                url: config.url + '/v1/dashboard/productprice/selfprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            console.log(res.data.message);
            setData({ ...data, price: res.data.message });
            setKeyprice(keyprice + 1);
        } catch (error) {

        }
    }
    const CreatePriceGroupFirst = async (newid: any) => {
        try {
            let res = await axios({
                method: 'post',
                data: {
                    name: newid,
                    model: 'selfprice',
                    url: newid
                },
                url: config.url + '/v1/dashboard/productprice/selfprice',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });


        } catch (error) {

        }
    }
    useEffect(() => {
        getalldata();

        load();
    }, []);
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="pb-8" dir="rtl">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="Edit Product"></HeaderOfPage>

            {
                data != null && <div className='grid grid-cols-1 lg:grid-cols-5 gap-6'>
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 sticky top-4">
                            <div className='mb-6'>
                                <div className="text-gray-800 text-right font-semibold mb-3 text-sm"> {t('Thumpnail')} </div>
                                <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                                    <ImageUploader id={data._id} component={'product'}></ImageUploader>
                                </div>
                            </div>
                            
                            <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent my-6"></div>
                            
                            <form key={key} className={`flex flex-col gap-4`}>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">{t('Name')}</label>
                                    <input
                                        defaultValue={data.name}
                                        type="text"
                                        className={`${inputstyle} ${error != null && error['name'] != undefined && `border-red-500 bg-red-50`}`}
                                        placeholder="نام محصول"
                                        onChange={(e) => setData({ ...data, name: e.target.value })}
                                    />
                                    {error != null && error['name'] != undefined && (
                                        <small className="text-red-500 text-xs mt-1 block">{error['name']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">Slug</label>
                                    <input
                                        type="text"
                                        defaultValue={data.url}
                                        className={`${inputstyle} ${error != null && error['url'] != undefined && `border-red-500 bg-red-50`}`}
                                        placeholder="slug-product"
                                        onChange={(e) => setData({ ...data, url: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && (
                                        <small className="text-red-500 text-xs mt-1 block">{error['url']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">{t('Group')}</label>
                                    <select
                                        value={data.parent}
                                        onChange={(e) => setData({ ...data, parent: e.target.value })}
                                        className={inputstyle}
                                    >
                                        <option value="">انتخاب گروه...</option>
                                        {
                                            list != null && list.map((item: any) => {
                                                return (
                                                    <optgroup label={item.name} key={item.id}>
                                                        <option value={item.id}>
                                                            {item.name}
                                                        </option>
                                                        {
                                                            item.togroup.map((p: any) => {
                                                                return (
                                                                    <option key={p.id} value={p.id}>{p.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </optgroup>)
                                            })
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">قیمت پایه</label>
                                    <input
                                        value={data.mainprice || ''}
                                        type="text"
                                        dir='ltr'
                                        className={`${inputstyle} ${error != null && error['mainprice'] != undefined && `border-red-500 bg-red-50`}`}
                                        placeholder="0"
                                        onChange={(e) => setData({ ...data, mainprice: e.target.value })}
                                    />
                                    {error != null && error['mainprice'] != undefined && (
                                        <small className="text-red-500 text-xs mt-1 block">{error['mainprice']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">وضعیت موجودی</label>
                                    <select
                                        value={data.isExisting === false ? 'false' : 'true'}
                                        onChange={(e) => setData({ ...data, isExisting: e.target.value === 'true' })}
                                        className={inputstyle}
                                    >
                                        <option value="true">موجود</option>
                                        <option value="false">ناموجود</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">نوع موجودی انبار</label>
                                    <select
                                        value={data.unlimitedStock === false ? 'limited' : 'unlimited'}
                                        onChange={(e) => setData({
                                            ...data,
                                            unlimitedStock: e.target.value === 'unlimited',
                                            stockCount: e.target.value === 'unlimited' ? 0 : (data.stockCount || 0),
                                        })}
                                        className={inputstyle}
                                    >
                                        <option value="unlimited">نامحدود</option>
                                        <option value="limited">محدود (تعداد مشخص)</option>
                                    </select>
                                </div>

                                {data.unlimitedStock === false && (
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">تعداد موجود در انبار</label>
                                        <input
                                            value={data.stockCount ?? 0}
                                            type="number"
                                            min={0}
                                            dir="ltr"
                                            className={inputstyle}
                                            placeholder="0"
                                            onChange={(e) => setData({ ...data, stockCount: Math.max(0, parseInt(e.target.value, 10) || 0) })}
                                        />
                                    </div>
                                )}

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">کد محصول</label>
                                    <Input
                                        dir='ltr'
                                        defaultValue={data.alt}
                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, alt: e })}
                                        placeholder="کد محصول..."
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">{t('Brand')}</label>
                                    <select
                                        value={data.brand || ''}
                                        onChange={(e) => setData({ ...data, brand: e.target.value })}
                                        className={inputstyle}
                                    >
                                        <option value="">انتخاب برند...</option>
                                        {
                                            Array.isArray(brands) && brands.length > 0 && brands.map((item: any) => {
                                                return (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">{t('مدل پخش')}</label>
                                    <select
                                        value={data.listmode}
                                        onChange={(e) => setData({ ...data, listmode: e.target.value })}
                                        className={inputstyle}
                                    >
                                        <option value={0}>{t('نوع یک')}</option>
                                        <option value={1}>{t('نوع دو')}</option>
                                        <option value={2}>{t('نوع سه')}</option>
                                    </select>
                                </div>

                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('جدیدترین ها')}</label>
                                        <select
                                            value={data.special}
                                            onChange={(e) => setData({ ...data, special: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value={0}>{t('خیر')}</option>
                                            <option value={1}>{t('بله')}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('پرفروش ها')}</label>
                                        <select
                                            value={data.firstpage}
                                            onChange={(e) => setData({ ...data, firstpage: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value={0}>{t('خیر')}</option>
                                            <option value={1}>{t('بله')}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('ویژه صفحه اول')}</label>
                                        <select
                                            value={data.special1}
                                            onChange={(e) => setData({ ...data, special1: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value={0}>{t('خیر')}</option>
                                            <option value={1}>{t('بله')}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('تخفیف دار')}</label>
                                        <select
                                            value={data.special3}
                                            onChange={(e) => setData({ ...data, special3: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value={0}>{t('خیر')}</option>
                                            <option value={1}>{t('بله')}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('دسته بندی محصولات')}</label>
                                        <select
                                            value={data.special2}
                                            onChange={(e) => setData({ ...data, special2: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value={0}>{t('خیر')}</option>
                                            <option value={1}>{t('بله')}</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">{t('محل صفحه اول')}</label>
                                        <select
                                            value={data.specialsection || ''}
                                            onChange={(e) => setData({ ...data, specialsection: e.target.value })}
                                            className={inputstyle}
                                        >
                                            <option value="">انتخاب کنید...</option>
                                            {
                                                list != null && list.map((item: any) => {
                                                    return (
                                                        <option key={item.id} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                <button 
                                    type="button"
                                    onClick={(e) => { save() }}
                                    disabled={saving}
                                    className="mt-4 py-3 px-6 inline-flex items-center justify-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none transition-all duration-200 shadow-md hover:shadow-lg"
                                >
                                    {saving ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                            در حال ذخیره...
                                        </>
                                    ) : (
                                        <>
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                            {t('Update Post')}
                                        </>
                                    )}
                                </button>


                            </form>



                        </div>
                    </div>
                    <div className='lg:col-span-4'>
                        <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                            <Tabs defaultActiveKey="1" appearance="pills">
                            <Tabs.Tab eventKey="1" title="متن">
                                <div className="p-6">
                                    <TissEditor component='prodcuts' parent={data.id} />
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="2" title="سئو">
                                <div className="p-6">
                                    <div className="flex flex-col gap-4 text-right" dir='rtl'>
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">تیتر</label>
                                            <Input
                                                defaultValue={data.title}
                                                className={inputstyle}
                                                onChange={(e) => setData({ ...data, title: e })}
                                                placeholder="تیتر صفحه..."
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">{t('Keywords')}</label>
                                            <Input
                                                as={'textarea'}
                                                rows={4}
                                                defaultValue={data.keywords}
                                                className={inputstyle}
                                                onChange={(e) => setData({ ...data, keywords: e })}
                                                placeholder="کلمات کلیدی (با کاما جدا کنید)..."
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">{t('Description')}</label>
                                            <Input
                                                as={`textarea`}
                                                rows={6}
                                                defaultValue={data.description}
                                                className={inputstyle}
                                                onChange={(e) => setData({ ...data, description: e })}
                                                placeholder="توضیحات متا..."
                                            />
                                        </div>
                                    </div>
                                    <Button 
                                        type="button"
                                        onClick={(e) => { save() }}
                                        disabled={saving}
                                        className='w-full sm:w-[300px] mt-6'
                                        appearance="primary"
                                    >
                                        {saving ? 'در حال ذخیره...' : 'ذخیره سازی'}
                                    </Button>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="3" title="قیمت گذاری">
                                <div className="p-6">
                                    <div className="flex flex-col gap-4">
                                        <h3 className="text-lg font-bold text-gray-800 mb-4">قیمت گذاری</h3>

                                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                                            <div>
                                                <Button
                                                    className='w-full'
                                                    appearance={data.price == data.id ? "primary" : "default"}
                                                    onClick={(e) => { CreatePriceGroup() }}
                                                >
                                                    قیمت گذاری انحصاری
                                                </Button>
                                            </div>
                                            <div className='flex flex-col sm:flex-row gap-2 items-start sm:items-center'>
                                                <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">استفاده از قیمت گذاری گروهی:</label>
                                                <select 
                                                    className={`${inputstyle} flex-1`}
                                                    value={data.price || ''}
                                                    onChange={(e) => { setData({ ...data, price: e.target.value }); setKeyprice(keyprice + 1) }}
                                                >
                                                    <option value="">انتخاب کنید...</option>
                                                    {
                                                        pricellist.map((item: any) => {
                                                            return (
                                                                <option key={item.id} value={item.id}>{item.name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        {data.price != null && data.price != "" && (
                                            <div className="mt-6 border-t border-gray-200 pt-6">
                                                <PriceEditor Id={data.price} key={keyprice} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="4" title="ویژگی ها">
                                <div className="p-6">
                                    <div className='flex flex-col gap-4'>
                                        <h3 className="text-lg font-bold text-gray-800 mb-2">ویژگی‌های محصول</h3>
                                        {
                                            data.toGroup?.feature != null && data.toGroup.feature.length > 0 ? (
                                                data.toGroup.feature.map((item: any) => {
                                                    return (
                                                        <div key={item} className="flex flex-col sm:flex-row gap-3 bg-gray-50 rounded-lg p-4 border border-gray-200">
                                                            <div className='sm:w-[200px] text-right font-semibold text-gray-700 flex items-center'>{item}</div>
                                                            <Input
                                                                className="flex-1"
                                                                defaultValue={data.feature != null ? data.feature[item] : ''}
                                                                placeholder={`مقدار ${item} را وارد کنید...`}
                                                                onChange={(e: any) => {
                                                                    setData((prevData: any) => ({
                                                                        ...prevData,
                                                                        feature: {
                                                                            ...prevData.feature,
                                                                            [item]: e,
                                                                        },
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    )
                                                })
                                            ) : (
                                                <div className="text-center py-8 text-gray-500">
                                                    ویژگی‌ای برای این محصول تعریف نشده است
                                                </div>
                                            )
                                        }

                                        <Button 
                                            type="button"
                                            onClick={(e) => { save() }}
                                            disabled={saving}
                                            className="mt-4 w-full sm:w-[300px]"
                                            appearance="primary"
                                        >
                                            {saving ? 'در حال ذخیره...' : t('Update Post')}
                                        </Button>
                                    </div>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="5" title="خصوصیات">
                                <div className="p-6">
                                    <div className='flex flex-col gap-4'>
                                        <h3 className="text-lg font-bold text-gray-800 mb-2">خصوصیات محصول</h3>
                                        <div>
                                            <label className="block text-sm font-semibold text-gray-700 mb-2">توضیحات</label>
                                            <Input
                                                defaultValue={data.description}
                                                onChange={(e) => {
                                                    setData({ ...data, description: e });
                                                }} 
                                                as={'textarea'} 
                                                rows={12}
                                                className={inputstyle}
                                                placeholder="خصوصیات و توضیحات محصول را وارد کنید..."
                                            />
                                        </div>

                                        <Button 
                                            type="button"
                                            onClick={(e) => { save() }}
                                            disabled={saving}
                                            className='w-full sm:w-[300px]'
                                            appearance="primary"
                                        >
                                            {saving ? 'در حال ذخیره...' : 'ذخیره سازی'}
                                        </Button>
                                    </div>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="6" title="سوالات متداول">
                                <div className="p-6">
                                    <QACreator parent={data.id}></QACreator>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="7" title="تصاویر">
                                <div className="p-6">
                                    <h3 className="text-lg font-bold text-gray-800 mb-4">گالری تصاویر</h3>
                                    <ImageUploaders count={1000} id={data.id} component={'OtherImage'}></ImageUploaders>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="8" title="نظرات">
                                <div className="p-6">
                                    <h3 className="text-lg font-bold text-gray-800 mb-4">نظرات محصول</h3>
                                    <div className="text-center py-8 text-gray-500">
                                        بخش نظرات در حال توسعه است
                                    </div>
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="9" title="رنگ‌ها">
                                <div className="p-6">
                                    {data && (
                                        <ColorManager
                                            key={`colors-${data.id}`}
                                            selectedColors={Array.isArray(data.colors) ? data.colors : []}
                                            onColorsChange={(colors) => {
                                                console.log('Colors changed:', colors);
                                                setData({ ...data, colors: colors });
                                            }}
                                        />
                                    )}
                                    <Button
                                        type="button"
                                        onClick={(e) => { save() }}
                                        disabled={saving}
                                        className="mt-6 w-full sm:w-[300px]"
                                        appearance="primary"
                                    >
                                        {saving ? 'در حال ذخیره...' : t('Update Post')}
                                    </Button>
                                </div>
                            </Tabs.Tab>
                        </Tabs>
                        </div>
                    </div>
                </div>
            }

        </div>
    )
}
